import { setContext } from '@apollo/client/link/context'
import { getToken, getCookie } from 'resources'
import { isPublicOperation } from './commons'

const authLink = setContext(async ({ operationName }, { headers }) => {
  if (isPublicOperation(operationName)) return { headers }

  let token = await getToken()

  if (!token) {
    token = await getCookie(process.env.REACT_APP_COOKIE_NAME)
  }

  if (!token) {
    return { headers }
  }

  return {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  }
})

export { authLink }
